@if (input_type() === "original") {
  <div class="price">
    <hr class="linev linev--white" />
    <div class="currency-display">
      <div class="usd-value">{{ input_price_usdValue() + " USD" }}</div>
      <hr class="line line--white" />
      <div class="tl-value">{{ input_price_tlValue() + " TL" }}</div>
    </div>
  </div>
} @else {
  <div class="price">
    <hr class="linev" />
    <div class="currency-display">
      <div class="usd-value usd-value--variant">
        {{ input_price_usdValue() + " USD" }}
      </div>
      <hr class="line" />
      <div class="tl-value tl-value--variant">
        {{ input_price_tlValue() }}
        <span class="small">TL </span>
      </div>
    </div>
  </div>
}
